import {Link} from "preact-router/match";
import {iconFooterSearchIcon, logoNewFooter} from "../../../../assets";
import {h} from "preact";
import {useBehavioralContext} from "../../../../contexts";
import {useUpperRow} from "./useUpperRow";

const UpperRow = () => {
    // Component logic data
    const componentProps = useUpperRow();

    // Destructured component logic data
    const {
        handleSearchButton
    } = componentProps;

    return (
        <div className="w-full flex flex-row justify-between gap-8 mt-6 xmd:mt-12 mb-6">
            <div className="flex">
                <Link
                    href="/"
                    data-testid="footer-logo-link"
                    onClick={() => {
                        window.location.pathname === "/" && window.location.reload();
                    }}
                >
                    <img
                        src={logoNewFooter}
                        alt="Footer logo"
                        className='w-[55px] select-none dark:grayscale'
                        data-testid="footer-logo-img"
                    />
                </Link>
            </div>
            <div className="flex">
                <button
                    type={"button"}
                    onClick={() => handleSearchButton()}
                >
                    <img
                        src={iconFooterSearchIcon}
                        alt="Footer search icon"
                        className='w-[55px] select-none dark:grayscale'
                        data-testid="footer-logo-img"
                    />
                </button>
            </div>
        </div>
    )
}

export default UpperRow;
